import IconAgent from './IconAgent'
import Box from '@mui/material/Box'

interface Props {
  token?: Token
}

export default function TokenIndicator({ token }: Props) {
  if (!token) return null
  return (
    <Box component="span" sx={{
      marginLeft: 0.5
    }}>
      <IconAgent width={12} height={12} offline={!token.enabled} />
    </Box>
  )
}
